import { Injectable } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';

export type ToastType = 'success' | 'info' | 'warning' | 'error';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly defaultOptions: Partial<IndividualConfig> = {
    positionClass: 'toast-bottom-full-width',
    closeButton: true,
    timeOut: 4000,
    extendedTimeOut: 1000,
    tapToDismiss: true,
    newestOnTop: true,
  };

  constructor(private readonly toastr: ToastrService) {}

  success(title: string, message?: string, options?: Partial<IndividualConfig>) {
    return this.show('success', title, message, options);
  }

  info(title: string, message?: string, options?: Partial<IndividualConfig>) {
    return this.show('info', title, message, options);
  }

  warning(title: string, message?: string, options?: Partial<IndividualConfig>) {
    return this.show('warning', title, message, options);
  }

  error(title: string, message?: string, options?: Partial<IndividualConfig>) {
    return this.show('error', title, message, options);
  }

  /**
   * Generic show.
   */
  show(type: ToastType, title: string, message?: string, options?: Partial<IndividualConfig>) {
    const finalOptions: Partial<IndividualConfig> = {
      ...this.defaultOptions,
      ...options,
    };

    const m = message ?? '';
    switch (type) {
      case 'success':
        return this.toastr.success(m, title, finalOptions);
      case 'info':
        return this.toastr.info(m, title, finalOptions);
      case 'warning':
        return this.toastr.warning(m, title, finalOptions);
      case 'error':
        return this.toastr.error(m, title, finalOptions);
    }
  }

  clearAll() {
    this.toastr.clear();
  }

  clearByToastId(toastId: number) {
    this.toastr.clear(toastId);
  }
}
